import { Colors } from 'copyright-clearance-center-common-ui';

const DropdownMenuSeparator: React.FunctionComponent = () => {
	return (
		<div
			style={{
				width: '100%',
				borderBottom: `1px solid ${Colors.neutral300}`,
				padding: '0'
			}}
		></div>
	);
};

export default DropdownMenuSeparator;
